import { render, staticRenderFns } from "./SearchingSolshareAlready.vue?vue&type=template&id=06fcbf0c&scoped=true"
import script from "./SearchingSolshareAlready.vue?vue&type=script&lang=js"
export * from "./SearchingSolshareAlready.vue?vue&type=script&lang=js"
import style0 from "./SearchingSolshareAlready.vue?vue&type=style&index=0&id=06fcbf0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fcbf0c",
  null
  
)

export default component.exports